import React from 'react';
import classNames from 'classnames';

export interface CircleProgressProps {
  className?: string;
  percentage: number;
}

export const CirclePercentageChart: React.FC<CircleProgressProps> = ({ className, percentage }) => {
  const _percentage = Math.min(100, Math.round(percentage));
  const containerClasses = classNames('w-40 h-40', className);
  const strokeDashoffset = 345.57 - (345.57 * _percentage) / 100;
  return (
    // @ts-ignore
    <div className={containerClasses}>
      <svg viewBox="0 0 120 120">
        <defs>
          <linearGradient id="gradientCircle">
            <stop offset="0%" className="ds-stop-chart-circle-start" />
            <stop offset="100%" className="ds-stop-chart-circle-end" />
          </linearGradient>
        </defs>
        <circle
          cx="60"
          cy="60"
          r="53"
          className="stroke-ds-text-inverse-2"
          strokeWidth="12"
          fill="transparent"
        />

        <circle
          style={{
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
            transition: 'stroke-dashoffset 0.5s ease-in-out',
            stroke: 'url(#gradientCircle)',
          }}
          cx="60"
          cy="60"
          r="53"
          strokeWidth="12"
          fill="transparent"
          strokeDasharray="345.57"
          strokeDashoffset={strokeDashoffset}
        />

        <text x="60" y="60" textAnchor="middle">
          <tspan className="text-ds-headline font-ds-500 text-ds-text-1" dy=".4em">
            {_percentage}
          </tspan>
          <tspan dy="0" className="text-ds-text-s font-ds-500 text-ds-text-1">
            %
          </tspan>
        </text>
      </svg>
    </div>
  );
};
